export enum GrafanaEvent {
  ActionButtonClicked = 'actionButtonClicked',
  FilterApplied = 'filterApplied',
  TabClicked = 'tabClicked',
}
